import {type FC} from 'react';
import {type TNetworkStatus} from '../../../utils/StreamingUtil.ts';
import {Bar, Dot, NetWorkStatusWrapper} from '../types/NetworkStatus.styled.ts';

interface NetworkStatusProps {
    status: TNetworkStatus;
}

interface INetworkStatus {
    status: TNetworkStatus;
    color: string;
}

const STATUS_CONFIG = {
    대기: {color: '#a3a3a3'},
    좋음: {color: '#4ade80'},
    보통: {color: '#60a5fa'},
    나쁨: {color: '#f472b6'},
};

const NetworkStatus: FC<NetworkStatusProps> = ({status}) => {
    const networkStatus: INetworkStatus = {
        status,
        color: STATUS_CONFIG[status].color,
    };

    return (
        <Bar>
            <NetWorkStatusWrapper>
                <Dot $color={networkStatus.color} />
                <span style={{color: networkStatus.color, fontWeight: '500'}}>네트워크</span>
                <span style={{color: networkStatus.color, fontWeight: '600'}}>{status}</span>
            </NetWorkStatusWrapper>
        </Bar>
    );
};

export default NetworkStatus;
